import styled, { css } from 'styled-components';

export const Outer = styled.div`
  pointer-events: all;
  position: absolute;
  height: 100%;
  width: 0;
  left: -38px;
  top: 0;
  z-index: 9;
  display: table;
  ${props =>
    props.tutorialLevel &&
    props.tutorialStarted &&
    props.tutorialLevel > 1 &&
    css`
      z-index: auto;
    `}
  ${props =>
    props.direction === 'right' &&
    css`
      left: 100%;
      right: -4px;
    `}
`;

export const Inner = styled.div`
  display: table-cell;
  width: 34px;
  ${props =>
    props.valign &&
    props.valign.match('middle') &&
    css`
      vertical-align: middle;
    `}

  ${props =>
    props.valign &&
    props.valign.match('top') &&
    css`
      vertical-align: top;
    `}

  ${props =>
    props.valign &&
    props.valign.match('bottom') &&
    css`
      vertical-align: bottom;
    `}

  ${props =>
    props.align &&
    props.align.match('left') &&
    css`
      text-align: left;
    `}

  ${props =>
    props.align &&
    props.align.match('right') &&
    css`
      text-align: right;
    `}

  ${props =>
    props.align &&
    props.align.match('center') &&
    css`
      text-align: center;
    `}
`;

export const Wrapper = styled.div`
  position: relative;
  left: 42px;
  ${props =>
    props.direction === 'right' &&
    css`
      left: auto;
      right: 44px;
    `}
`;
